import { createTheme }  from '@mui/material/styles'
const theme = createTheme({
    typography: {
        fontFamily: 'GalanoGrotesque',
    },
    palette: {
        primary: {
            main: '#0C2043',
        },
        secondary: {
            main: '#0096C8',
        },
        error: {
            main: '#f44336',
        },
        warning: {
            main: '#ff9800',
        },
        info: {
            main: '#2196f3',
        },
        success: {
            main: '#4caf50',
        },
        text: {
            primary: '#0C2043',
        },
        background: {
            default: '#ffffff',
        },
    },
})
export default theme